import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as G } from "../../_mixins/use-rtl.js";
import { resolveWrappedSlot as i, ensureValidVNode as c } from "../../_utils/vue/resolve-slot.js";
import J from "./styles/index.cssr.js";
import Q from "../../_mixins/use-config.js";
import v from "../../_mixins/use-theme.js";
import { createKey as p } from "../../_utils/cssr/index.js";
import { getMargin as U } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as X } from "../../_mixins/use-css-vars-class.js";
import { call as Y } from "../../_utils/vue/call.js";
import Z from "../styles/light.js";
import ee from "../../_internal/close/src/Close.js";
import { keysOf as oe } from "../../_utils/vue/keysOf.js";
import { defineComponent as te, computed as b, h as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const S = {
  title: [String, Function],
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  headerExtraClass: String,
  headerExtraStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: !1
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  },
  cover: Function,
  content: [String, Function],
  footer: Function,
  action: Function,
  headerExtra: Function
}, be = oe(S), re = Object.assign(Object.assign({}, v.props), S), ve = te({
  name: "Card",
  props: re,
  slots: Object,
  setup(o) {
    const f = () => {
      const {
        onClose: r
      } = o;
      r && Y(r);
    }, {
      inlineThemeDisabled: a,
      mergedClsPrefixRef: e,
      mergedRtlRef: g
    } = Q(o), d = v("Card", "-card", J, Z, o, e), u = G("Card", g, e), h = b(() => {
      const {
        size: r
      } = o, {
        self: {
          color: t,
          colorModal: l,
          colorTarget: C,
          textColor: m,
          titleTextColor: y,
          titleFontWeight: x,
          borderColor: $,
          actionColor: z,
          borderRadius: E,
          lineHeight: R,
          closeIconColor: _,
          closeIconColorHover: B,
          closeIconColorPressed: P,
          closeColorHover: F,
          closeColorPressed: O,
          closeBorderRadius: j,
          closeIconSize: T,
          closeSize: I,
          boxShadow: V,
          colorPopover: k,
          colorEmbedded: H,
          colorEmbeddedModal: w,
          colorEmbeddedPopover: M,
          [p("padding", r)]: N,
          [p("fontSize", r)]: K,
          [p("titleFontSize", r)]: L
        },
        common: {
          cubicBezierEaseInOut: W
        }
      } = d.value, {
        top: A,
        left: D,
        bottom: q
      } = U(N);
      return {
        "--n-bezier": W,
        "--n-border-radius": E,
        "--n-color": t,
        "--n-color-modal": l,
        "--n-color-popover": k,
        "--n-color-embedded": H,
        "--n-color-embedded-modal": w,
        "--n-color-embedded-popover": M,
        "--n-color-target": C,
        "--n-text-color": m,
        "--n-line-height": R,
        "--n-action-color": z,
        "--n-title-text-color": y,
        "--n-title-font-weight": x,
        "--n-close-icon-color": _,
        "--n-close-icon-color-hover": B,
        "--n-close-icon-color-pressed": P,
        "--n-close-color-hover": F,
        "--n-close-color-pressed": O,
        "--n-border-color": $,
        "--n-box-shadow": V,
        // size
        "--n-padding-top": A,
        "--n-padding-bottom": q,
        "--n-padding-left": D,
        "--n-font-size": K,
        "--n-title-font-size": L,
        "--n-close-size": I,
        "--n-close-icon-size": T,
        "--n-close-border-radius": j
      };
    }), n = a ? X("card", b(() => o.size[0]), h, o) : void 0;
    return {
      rtlEnabled: u,
      mergedClsPrefix: e,
      mergedTheme: d,
      handleCloseClick: f,
      cssVars: a ? void 0 : h,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    const {
      segmented: o,
      bordered: f,
      hoverable: a,
      mergedClsPrefix: e,
      rtlEnabled: g,
      onRender: d,
      embedded: u,
      tag: h,
      $slots: n
    } = this;
    return d == null || d(), s(h, {
      class: [`${e}-card`, this.themeClass, u && `${e}-card--embedded`, {
        [`${e}-card--rtl`]: g,
        [`${e}-card--content${typeof o != "boolean" && o.content === "soft" ? "-soft" : ""}-segmented`]: o === !0 || o !== !1 && o.content,
        [`${e}-card--footer${typeof o != "boolean" && o.footer === "soft" ? "-soft" : ""}-segmented`]: o === !0 || o !== !1 && o.footer,
        [`${e}-card--action-segmented`]: o === !0 || o !== !1 && o.action,
        [`${e}-card--bordered`]: f,
        [`${e}-card--hoverable`]: a
      }],
      style: this.cssVars,
      role: this.role
    }, i(n.cover, (r) => {
      const t = this.cover ? c([this.cover()]) : r;
      return t && s("div", {
        class: `${e}-card-cover`,
        role: "none"
      }, t);
    }), i(n.header, (r) => {
      const {
        title: t
      } = this, l = t ? c(typeof t == "function" ? [t()] : [t]) : r;
      return l || this.closable ? s("div", {
        class: [`${e}-card-header`, this.headerClass],
        style: this.headerStyle,
        role: "heading"
      }, s("div", {
        class: `${e}-card-header__main`,
        role: "heading"
      }, l), i(n["header-extra"], (C) => {
        const m = this.headerExtra ? c([this.headerExtra()]) : C;
        return m && s("div", {
          class: [`${e}-card-header__extra`, this.headerExtraClass],
          style: this.headerExtraStyle
        }, m);
      }), this.closable && s(ee, {
        clsPrefix: e,
        class: `${e}-card-header__close`,
        onClick: this.handleCloseClick,
        absolute: !0
      })) : null;
    }), i(n.default, (r) => {
      const {
        content: t
      } = this, l = t ? c(typeof t == "function" ? [t()] : [t]) : r;
      return l && s("div", {
        class: [`${e}-card__content`, this.contentClass],
        style: this.contentStyle,
        role: "none"
      }, l);
    }), i(n.footer, (r) => {
      const t = this.footer ? c([this.footer()]) : r;
      return t && s("div", {
        class: [`${e}-card__footer`, this.footerClass],
        style: this.footerStyle,
        role: "none"
      }, t);
    }), i(n.action, (r) => {
      const t = this.action ? c([this.action()]) : r;
      return t && s("div", {
        class: `${e}-card__action`,
        role: "none"
      }, t);
    }));
  }
});
export {
  be as cardBasePropKeys,
  S as cardBaseProps,
  re as cardProps,
  ve as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/card/src/Card.js
// module id = 24
// module chunks = 67